import { AppName, UnsubscribeReason } from 'root-constants'

export const FLOW_REASON_VALUES: Partial<Record<AppName, UnsubscribeReason[]>> =
  {
    [AppName.FEMI]: [
      UnsubscribeReason.TOO_EXPENSIVE,
      UnsubscribeReason.DO_NOT_LIKE_PROGRAM,
      UnsubscribeReason.DID_NOT_GET_WHAT_EXPECTED,
      UnsubscribeReason.TIMING_IS_NOT_RIGHT,
      UnsubscribeReason.TECH_ISSUES,
      UnsubscribeReason.OTHER,
    ],
    [AppName.LUVLY]: [
      UnsubscribeReason.TIMING_IS_NOT_RIGHT,
      UnsubscribeReason.TOO_EXPENSIVE,
      UnsubscribeReason.DO_NOT_LIKE_PROGRAM,
      UnsubscribeReason.TECH_ISSUES,
      UnsubscribeReason.OTHER,
    ],
  }
